import React from 'react';
import { BaseFieldProps, Field, WrappedFieldProps } from 'redux-form';
import { Control, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import { omit } from 'lodash';
import { ColorInput, ColorInputOwnProps } from './color-input';

export function ColorInputHookForm<T extends FieldValues>(
  props: Omit<ColorInputOwnProps, 'input'> & UseControllerProps<T> & { control: Control<T> },
) {
  const { field } = useController(props);
  return (
    <ColorInput
      {...props}
      input={{
        value: field.value,
        onChange: field.onChange,
      }}
    />
  );
}

const ReduxFormField = (props: WrappedFieldProps & ColorInputOwnProps) => {
  return (
    <ColorInput
      input={props.input}
      {...omit(props, ['input', 'meta'])}
    />
  );
};

const ColorInputField = ({ name, ...props }: BaseFieldProps & ColorInputOwnProps) => (
  <Field
    id={name}
    name={name}
    component={ReduxFormField}
    props={props}
  />
);

export default ColorInputField;
